import { ReactNode } from 'react';

type ChildrenProps = {
  children?: ReactNode;
};

const withStringOrComponent = <Props extends ChildrenProps>(
  value: ReactNode,
  WrappedComponent: React.ComponentType<Props>,
) => {
  return typeof value === 'string' ? (
    <WrappedComponent {...({ children: value } as Props)} />
  ) : (
    value
  );
};

export default withStringOrComponent;
